"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _index = _interopRequireDefault(require("@/directive/permission/index.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
// 权限判断指令
var _default = exports.default = {
  directives: {
    permission: _index.default
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          id: '',
          uuid: '',
          prefix: '',
          givenName: '',
          middleName: '',
          familyName: '',
          suffix: '',
          genderCode: '',
          race: '',
          nationality: '',
          phone: '',
          mobile: '',
          birthday: '',
          website: '',
          jobTitle: '',
          department: '',
          orgName: '',
          yrInRole: '',
          bio: '',
          othEmail: [{
            emailType: 'Work',
            value: ''
          }, {
            emailType: 'Work',
            value: ''
          }]
        };
      }
    },
    proOrganizationList: {
      type: Array,
      default: () => [],
      // 默认空数组
      validator: value => value === null || Array.isArray(value) // 允许 null 或数组
    }
  },
  data() {
    return {
      countryList: [],
      genderList: [],
      prefixList: ['', 'Mr', 'Miss', 'Mrs', 'Ms', 'Dr', 'Prof', 'Sir', 'Lady'],
      suffixList: ['', 'Sr.', 'Jr.', 'II', 'III'],
      yearInRoleList: ['0-1', '2-5', '6-10', '11-15', '15+'],
      typeList: ['Home', 'Work', 'Other'],
      selectedUser: {},
      organizationList: []
    };
  },
  async created() {
    //await this.getList()
    // console.log('page-user-acount-user', this.user)
    var tmpEmail = this.user.othEmail.length > 0 ? this.user.othEmail : [{
      emailType: 'Work',
      value: ''
    }, {
      emailType: 'Work',
      value: ''
    }];
    this.organizationList = this.proOrganizationList || [];
    console.log('organizationList', this.organizationList);
    console.log('proOrganizationList', this.proOrganizationList);
    this.selectedUser = {
      id: this.user.id,
      uuid: this.user.uuid,
      prefix: this.user.prefix,
      givenName: this.user.givenName,
      middleName: this.user.middleName,
      familyName: this.user.familyName,
      suffix: this.user.suffix,
      genderCode: this.user.genderCode,
      race: this.user.race,
      nationality: this.user.nationality,
      phone: this.user.phone,
      mobile: this.user.mobile,
      website: this.user.website,
      birthday: this.user.birthday,
      jobTitle: this.user.jobTitle,
      department: this.user.department,
      orgName: this.user.orgName,
      yrInRole: this.user.yrInRole,
      bio: this.user.bio,
      othEmail: tmpEmail,
      organizationMembers: this.user.organizationMembers.length > 0 ? [{
        organizationId: this.user.organizationMembers[0].organization.id
      }] : [{
        organizationId: ''
      }]
    };
    this.$store.dispatch('facets/getInitData', 'en').then(() => {
      this.countryList = this.$store.getters.countries;
      this.genderList = this.$store.getters.genders;
    });
  },
  methods: {
    checkPermission: _permission.default,
    // getList() {
    //   const token = getCookie('ACCESS_TOKEN')

    //  return getAllOrganizations(token)
    //     .then(response => {
    //       this.organizationList = response.data.rows

    //     })
    //     .catch(error => {
    //       showDebugLog('getAllOrganizations-api-error', error)

    //       displayPopupMessage(error, 'error')
    //       // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
    //     })
    // },
    save() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const email = (0, _cookie.getCookie)('EMAIL');
      if (this.selectedUser.givenName === "") {
        const msg = "Given name is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      if (this.selectedUser.familyName === "") {
        const msg = "Surname is missing";
        (0, _log.displayPopupMessage)(msg, "error");
        return;
      }
      // console.log('token', token)
      const userToSubmit = {
        ...this.selectedUser,
        organizationMembers: this.selectedUser.organizationMembers[0].organizationId === '' ? [] : this.selectedUser.organizationMembers
      };
      (0, _user.updateUserProfile)(token, userToSubmit).then(response => {
        const data = response.data;
        // console.log('page-user-save', response)
        this.selectedUser.prefix = data.prefix;
        this.selectedUser.givenName = data.givenName;
        this.selectedUser.middleName = data.middleName;
        this.selectedUser.familyName = data.familyName;
        this.selectedUser.suffix = data.suffix;
        this.selectedUser.genderCode = data.genderCode;
        this.selectedUser.race = data.race;
        this.selectedUser.nationality = data.nationality;
        this.selectedUser.phone = data.phone;
        this.selectedUser.mobile = data.mobile;
        this.selectedUser.website = data.website;
        this.selectedUser.birthday = data.birthday;
        this.selectedUser.genderCode = data.genderCode;
        this.selectedUser.jobTitle = data.jobTitle;
        this.selectedUser.department = data.department;
        this.selectedUser.orgName = data.orgName;
        this.selectedUser.yrInRole = data.yrInRole;
        this.selectedUser.bio = data.bio;
        this.selectedUser.othEmail = data.othEmail;
        this.selectedUser.organizationMembers = data.organizationMembers.length > 0 ? [{
          organizationId: data.organizationMembers[0].organization.id
        }] : [{
          organizationId: ''
        }];
        (0, _log.displayPopupMessage)('User information has been updated successfully', 'success');
        (0, _ga.writeGaEvent)(this, 'User', 'Update User Profile', email, `User Profile: ${data.uuid}`);
      }).catch(error => {
        (0, _log.showDebugLog)('Page-user-Save-Err', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    }
  }
};